import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export function formatINR(v) {
  const n = Number(v || 0);
  return `₹ ${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatRole(role) {
  const labels = {
    user: "User",
    analyst_admin: "Analyst Admin",
    business_admin: "Business Admin",
    super_admin: "Super Admin",
  };
  return labels[role] || String(role || "").replace(/_/g, " ");
}

export const STATUS_LABEL = {
  submitted: "Submitted",
  under_review: "Under Review",
  revision: "Revision",
  resubmitted: "Resubmitted",
  queued: "Queued",
  running: "Running",
  success: "Success",
  quality_review: "Quality Review",
  completed: "Completed",
  failed: "Failed",
  reprocessing: "Reprocessing",
  rejected: "Rejected",
  closed: "Closed",
};

export const STATUS_PILL = {
  submitted:      "bg-gray-100 text-gray-800 border-gray-200",
  under_review:   "bg-amber-50 text-amber-700 border-amber-200",
  revision:       "bg-orange-50 text-orange-700 border-orange-200",
  resubmitted:    "bg-blue-50 text-blue-700 border-blue-200",
  queued:         "bg-slate-50 text-slate-700 border-slate-200",
  running:        "bg-[#EAF4E3] text-[#3F6528] border-[#538135]/30",
  success:        "bg-green-50 text-green-700 border-green-200",
  quality_review: "bg-teal-50 text-teal-700 border-teal-200",
  completed:      "bg-green-100 text-green-800 border-green-300",
  failed:         "bg-red-50 text-red-700 border-red-200",
  reprocessing:   "bg-amber-50 text-amber-700 border-amber-200",
  rejected:       "bg-rose-50 text-rose-700 border-rose-200",
  closed:         "bg-gray-200 text-gray-700 border-gray-300",
};
